import React from 'react'
import './LoadingScreen.css'

const LoadingScreen = ({ size = 60, minHeight = '60vh' }) => {
  return (
    <div className="loading-screen" style={{ minHeight }}>
      <div
        className="loading-spinner"
        style={{ width: `${size}px`, height: `${size}px` }}
      />
    </div>
  )
}

export default LoadingScreen
